<template>
    <div v-if="showPhoneUI">
        <slot></slot>
    </div>
</template>

<script>
export default {
    computed: {
        sipClientId() {
            return this.$store.state.userPreferences.userParameters.SIP_CLIENT_ID;
        },
        showPhoneUI() {
            return this.$UIPrivilege('dispatching', 'voip_phone') && this.sipClientId
        }
    }
}
</script>

<style>

</style>